import type {
  Block,
  CalloutData,
} from "../../../../models/ManualAuthoring";
import RefLink from "../editor/RefLink";
import "./note.css";

export default function NoteView({ block }: { block: Block }) {
  const data = block.data as CalloutData;

  return (
    <div className="pdf-block pdf-note">
      <div className="pdf-note__line">
        <span className="pdf-note__label">NOTE:</span>
        <span className="pdf-note__content">
          {(data.textParts || []).map((part, i) => {
            if (part.type === "text") {
              return <span key={i}>{part.value}</span>;
            }

            return (
              <RefLink
                key={i}
                targetId={part.targetId}
                label={part.label}
                className="pdf-ref-link text-primary"
              />
            );
          })}
        </span>
      </div>
    </div>
  );
}
